module.exports = __webpack_public_path__ + "img/nodeType2.74a06ad3.svg";